import { render, staticRenderFns } from "./FormControlTagsTagUsage.vue?vue&type=template&id=cfd17b4c"
import script from "./FormControlTagsTagUsage.vue?vue&type=script&setup=true&lang=js"
export * from "./FormControlTagsTagUsage.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports